<h2 mat-dialog-title>Void Purchase</h2>
<mat-dialog-content class="dialog">
  <p>
    Voiding a purchase stops dunning, and will make the purchase non-retryable.
    A purchase should be voided in cases where the purchase should not have been
    attempted in the first place.
    <br />
    Are you sure you want to void this purchase for
    <strong>{{ purchase.total | price: usd:null:true:false }}</strong>
    ?
  </p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button color="primary" mat-dialog-close>Cancel</button>
  <button
    mat-raised-button
    color="primary"
    (click)="voidPurchase()"
    [disabled]="loading"
  >
    Void
  </button>
</mat-dialog-actions>
